<template>
  <b-modal
    id="manual-verify-modal"
    tittle="Manual Verify"
    hide-footer
    centered
    size="sm"
  >
    <!-- TITLE -->
    <div class="text-center">
      <h3 class="font-weight-bold text-black">Change Status - MANUAL VERIFY</h3>
    </div>

    <!-- USER NAME -->
    <div class="text-center">
      <p class="text-muted font-weight-bold">Name</p>
      <div class="text-black" style="font-size: 20px; font-weight: bold">
        {{ fullName }} ({{ gender === "M" ? "Male" : "Female" }})
      </div>
    </div>

    <template v-if="fullName && email && phoneNumber && gender">
      <!-- SUBTEXT -->
      <p class="text-center text-muted">
        Change details if needed. This action will<br />
        deactivate the user's account
      </p>

      <!-- NAME -->
      <b-form-group label="Name:" label-class="font-weight-bold text-black">
        <b-form-input
          :value="fullName"
          disabled
          placeholder="Enter name"
        ></b-form-input>
      </b-form-group>

      <!-- EMAIL -->
      <b-form-group label="Email:" label-class="font-weight-bold text-black">
        <b-form-input :value="email" type="email" disabled></b-form-input>
      </b-form-group>

      <!-- MOBILE -->
      <b-form-group label="Mobile:" label-class="font-weight-bold text-black">
        <b-form-input
          :value="phoneNumber"
          placeholder="Enter mobile number"
          disabled
        ></b-form-input>
      </b-form-group>
    </template>

    <!-- BUTTONS -->
    <div class="d-flex justify-content-between mt-2" style="gap: 12px">
      <!-- CANCEL -->
      <b-button
        class="flex-grow-1 font-weight-bold"
        @click="$bvModal.hide('manual-verify-modal')"
      >
        CANCEL
      </b-button>

      <!-- CONFIRM -->
      <b-button
        class="flex-grow-1 font-weight-bold"
        variant="danger"
        @click="handleVerifyProfile"
      >
        CONFIRM
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton, BFormGroup, BFormInput } from "bootstrap-vue";
import { stringProp } from "@/helpers/props";
import { mapActions } from "vuex";

export default {
  components: {
    BModal,
    BButton,
    BFormGroup,
    BFormInput,
  },
  props: {
    email: stringProp(),
    phoneNumber: stringProp(),
    fullName: stringProp(),
    gender: stringProp(),
  },
  methods: {
    ...mapActions("user/detail", {
      updateClientProfile: "updateClientProfile",
      fetchUser: "user/detail/asyncUser",
    }),
    async handleVerifyProfile() {
      const result = await this.updateClientProfile({
        userId: this.$route.params.id,
        isVerified: 1,
      });
      if (result) {
        this.$bvModal.hide("manual-verify-modal");
        this.fetchUser({ id: this.$router.currentRoute.params.id });

      }
    },
  },
};
</script>
